<h1 mat-dialog-title class="no-margin">ASSOCIA CLASSIFICAZIONI
  <mat-icon class="close-icon"
            (click)="onNoClick()">close
  </mat-icon>
</h1>
<h1 class="istruzioni" *ngIf="data.permission">Per associare le classificazioni trascinale nella lista "classificazioni
  associate"
</h1>

<mat-tab-group (selectedTabChange)="onTabChanged($event);">
  <mat-tab label="{{label}}" *ngFor="let label of labels" [disabled]="data.element.tipologia && data.element.tipologia.id===6 && label !== 'ADA'">

    <div class="flex-center mt-25" *ngIf="data.permission && (label === 'ISTAT' || label === 'ATECO')">
      <p class="text-lg">{{ label }} per codici ADA selezionati</p>

      <label class="switch">
        <input type="checkbox" [ngModel]="searchByAda" (change)="handleSearchByAda(label)" disabled="{{disableFilterByAdaSwitch}}" >
        <span class="slider round"></span>
      </label>
    </div>

    <div class="dialog-body-overflow">
      <div cdkDropListGroup>
        <div class="associazione-competenze-container" *ngIf="data.permission">
          <mat-accordion *ngIf="label !== 'ISCO'">
            <mat-expansion-panel hideToggle *ngIf="!(data.element.tipologia && data.element.tipologia.id===6)">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h3>
                    <mat-icon class="green"
                              style="position: relative; bottom: -5px; margin-right:5px;">menu
                    </mat-icon>
                    Ricerca per area
                  </h3>
                </mat-panel-title>

              </mat-expansion-panel-header>
              <mat-form-field class="full-width margin-bottom-10">
                <mat-select [(ngModel)]="area" name="area" placeholder="Seleziona area"
                            (selectionChange)="filterArea($event)">
                  <mat-option *ngFor="let item of getAreas(label)" [value]="item">
                    {{ item.descrizione }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="full-width margin-bottom-10" *ngIf="(label == 'ATECO') && area">
                <mat-select [(ngModel)]="sottoarea" name="sottoarea" placeholder="Seleziona sottoarea"
                            (selectionChange)="filterSottoArea($event)">
                  <mat-option *ngFor="let item of sottoaree" [value]="item">
                    {{ item.descrizione }}
                  </mat-option>
                </mat-select>
              </mat-form-field>


              <mat-form-field class="full-width margin-bottom-10"
                              *ngIf="(label == 'ADA' && listaProcessi)">
                <mat-select [(ngModel)]="processo" name="processi" placeholder="Seleziona processo"
                            (selectionChange)="filterProcessi($event,processo)">
                  <mat-option *ngFor="let item of listaProcessi" [value]="item">
                    {{ item.descrizione }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="full-width margin-bottom-10"
                              *ngIf="(label == 'ADA' && listaSequenze)">
                <mat-select [(ngModel)]="sequenza" name="sequenze" placeholder="Seleziona sequenza"
                            (selectionChange)="filterSequenze($event)">
                  <mat-option *ngFor="let item of listaSequenze" [value]="item">
                    {{ item.descrizione }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-expansion-panel>

            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" *ngIf="!(data.element.tipologia && data.element.tipologia.id===6)">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h3>
                    <mat-icon class="green"
                              style="position: relative; bottom: -5px; margin-right:5px;">menu
                    </mat-icon>
                    Ricerca {{ label }} per Cod/Desc
                  </h3>
                </mat-panel-title>

              </mat-expansion-panel-header>
              <mat-form-field class="full-width" *ngIf="label !== 'ISCO'">
                <mat-label>Ricerca {{ label }} per Cod/Desc</mat-label>
                <input [(ngModel)]="searchText" matInput placeholder="Ricerca">
                <button [disabled]="!searchText" *ngIf="(label == 'ADA' || label =='ATECO')" mat-fab
                        extended class="search_button custom-button searchbox-buttons save-button"
                        (click)="searchByString(searchText, false)">

                  <mat-icon>search</mat-icon>
                </button>
                <button [disabled]="!searchText" *ngIf="label == 'ISTAT'" mat-fab
                        extended class="search_button custom-button searchbox-buttons save-button"
                        (click)="filterList(searchText)">
                  <mat-icon>search</mat-icon>
                </button>
              </mat-form-field>

            </mat-expansion-panel>


          </mat-accordion>
          <div style="display:block; height:15px;" *ngIf="(label != 'ISCO') && !(data.element.tipologia && data.element.tipologia.id===6 && label === 'ADA')"></div>
          <div style="display:block; height:88px;" *ngIf="(label == 'ISCO') ">
            <mat-form-field class="full-width-c" *ngIf="label == 'ISCO'">
              <mat-label>Ricerca {{ label }} per Cod/Desc</mat-label>
              <input [(ngModel)]="searchText" matInput placeholder="Ricerca">
              <button [disabled]="!searchText" *ngIf="label == 'ISCO' " mat-fab
                      extended class="search_button custom-button searchbox-buttons save-button"
                      (click)="filterList(searchText)">
                <mat-icon>search</mat-icon>
              </button>
            </mat-form-field>

          </div>
          <div style="display:block; height:88px;" *ngIf="(data.element.tipologia && data.element.tipologia.id===6 && label === 'ADA')">
            <mat-form-field class="full-width-c" *ngIf="(data.element.tipologia && data.element.tipologia.id===6 && label === 'ADA')">
              <mat-label>Ricerca {{ label }} per Cod/Desc</mat-label>
              <input [(ngModel)]="searchText" matInput placeholder="Ricerca">
              <button [disabled]="!searchText" *ngIf="(data.element.tipologia && data.element.tipologia.id===6 && label === 'ADA')" mat-fab
                      extended class="search_button custom-button searchbox-buttons save-button"
                      (click)="searchByString(searchText, true)">
                <mat-icon>search</mat-icon>
              </button>
            </mat-form-field>

          </div>
          <div cdkDropList [cdkDropListData]="filteredLista" class="competenze-list" id="listaCompetenze"
               (cdkDropListDropped)="drop($event)">
            <div class="competenze-box" *ngFor="let item of filteredLista" cdkDrag>
              <p style="display:block; width:100%;">
                <span *ngIf="item.codiceAda" class="primary-details">{{ item.codiceAda }} - </span>
                <span *ngIf="item.codiceAteco" class="primary-details">{{ item.codiceAteco }} - </span>
                <span *ngIf="item.codiceIsco" class="primary-details">{{ item.codiceIsco }} - </span>
                <span *ngIf="item.codiceIstat" class="primary-details">{{ item.codiceIstat }} - </span>

                <span *ngIf="!item.codiceIstat" class="secondary-details">{{ item.descrizione }}</span>
                <span *ngIf="item.codiceIstat" class="secondary-details">{{ item.nome }}</span>
              </p>


            </div>
          </div>
          <mat-paginator #paginator [pageSize]="10" [length]="pageLength" [pageIndex]="0" showFirstLastButtons
                         (page)="onPaginateChange($event)"></mat-paginator>
        </div>

        <div class="associazione-competenze-container" [ngClass]="{'fullWidth':!data.permission}">
          <mat-form-field class="full-width margin-bottom-10">
            <mat-label>Ricerca class. associate {{ label }}</mat-label>
            <input matInput placeholder="Ricerca" (input)="filterListAssociate($event)">
            <mat-icon class="search">search</mat-icon>
          </mat-form-field>
          <div cdkDropList [cdkDropListData]="filteredListaAssociate" class="competenze-list"
               id="competenzeAssociate" (cdkDropListDropped)="drop($event)">
            <div class="competenze-box" *ngFor="let item of filteredListaAssociate" cdkDrag>
              <p style="display:block; width:100%;">
                <span *ngIf="item.codiceAda" class="primary-details">{{ item.codiceAda }} - </span>
                <span *ngIf="item.codiceAteco" class="primary-details">{{ item.codiceAteco }} - </span>
                <span *ngIf="item.codiceIsco" class="primary-details">{{ item.codiceIsco }} - </span>
                <span *ngIf="item.codiceIstat" class="primary-details">{{ item.codiceIstat }} - </span>
                <span *ngIf="!item.codiceIstat" class="secondary-details">{{ item.descrizione }}</span>
                <span *ngIf="item.codiceIstat" class="secondary-details">{{ item.nome }}</span>
              </p>

            </div>
          </div>
        </div>
      </div>
    </div>

  </mat-tab>

</mat-tab-group>
<div mat-dialog-actions class="actions">
  <button mat-fab extended class="searchbox-buttons ripristina-button" (click)="onNoClick()">
    <mat-icon>close</mat-icon>
    Chiudi
  </button>
  <button mat-fab extended class="searchbox-buttons save-button" [disabled]="!data.permission"
          (click)="associaClassificazioni(filteredListaAssociate)">
    <mat-icon>compare_arrows</mat-icon>
    Salva
  </button>
</div>
